var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValveBoxTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3e4346",
    d: "M12,0A12,12,0,1,0,24,12,12.035,12.035,0,0,0,12,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5,5V19H19V5Zm7,7L6.1,17.9h0V6.1h0L12,12l5.9-5.9V17.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValveBoxTour);
export default __webpack_public_path__ + "static/media/valve-box-tour.dacaf0c26921a270cec8fff764c20022.svg";
export { ForwardRef as ReactComponent };